import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { TooltipComponent } from "./tooltip.component";
import { TransitionModule } from "../transition/transition.module";
import { IconModule } from "../icon/icon.module";

@NgModule({
	declarations: [TooltipComponent],
	imports: [CommonModule, TransitionModule, IconModule],
	exports: [TooltipComponent]
})
export class TooltipModule {}
